import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus, Trash2, FileText, Upload, X } from "lucide-react";

export const emptyEntry = () => ({ driverId: "", driverName: "", dlNumber: "", dlState: "", file: null });

export function ResultDrop({ entry, onChange, tid = "" }) {
  return (
    <div className="mt-2 flex items-center justify-between gap-2 rounded-md border border-dashed border-violet-300 bg-violet-50 px-2.5 py-2" data-testid={`build-bill-result-drop${tid}`}>
      <div className="min-w-0 text-xs">
        {entry.file ? <span className="inline-flex items-center gap-1 text-violet-900 font-medium min-w-0"><FileText className="h-3.5 w-3.5 shrink-0" /><span className="truncate">{entry.file.name}</span></span>
          : <span className="text-violet-800">Result PDF ready? Attach it now — marks the request completed and files it on the driver.</span>}
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <label className="inline-flex items-center gap-1 text-xs text-violet-800 cursor-pointer hover:underline"><Upload className="h-3.5 w-3.5" />{entry.file ? "Replace" : "Attach result"}
          <input type="file" accept="application/pdf,image/*" className="hidden" onChange={(e) => onChange({ ...entry, file: e.target.files?.[0] || null })} data-testid={`build-bill-result-file${tid}`} /></label>
        {entry.file && <button type="button" onClick={() => onChange({ ...entry, file: null })} data-testid={`build-bill-result-clear${tid}`}><X className="h-3.5 w-3.5 text-slate-500" /></button>}
      </div>
    </div>
  );
}

export function entryState(e, drivers) {
  const d = drivers.find((x) => x.id === e.driverId);
  return ((d?.license_state || (!e.driverId ? e.dlState : "")) || "").toUpperCase();
}

export function DriverEntry({ entry, index, drivers, hasMvr, hasResult, multi, disabled, onChange, onRemove }) {
  const pick = (v) => {
    const id = v === "none" ? "" : v;
    const d = drivers.find((x) => x.id === id);
    onChange({ ...entry, driverId: id, dlNumber: d ? (d.license_number || "") : entry.dlNumber, dlState: d ? (d.license_state || "") : entry.dlState });
  };
  const tid = multi ? `-${index}` : "";
  return (
    <div className={multi ? "rounded-md border border-slate-200 p-2.5 bg-white" : ""} data-testid={`build-bill-driver-entry${tid}`}>
      <div className="flex items-end gap-2">
        <div className="flex-1 min-w-0">
          {multi && <Label className="text-xs text-slate-500">Driver {index + 1}</Label>}
          <Select value={entry.driverId || "none"} onValueChange={pick} disabled={disabled}>
            <SelectTrigger data-testid={`build-bill-driver-select${tid}`}><SelectValue placeholder="No driver / company-level" /></SelectTrigger>
            <SelectContent><SelectItem value="none">— None / type a name —</SelectItem>{drivers.map((d) => <SelectItem key={d.id} value={d.id}>{d.first_name} {d.last_name} · {d.license_state}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        {multi && <Button type="button" size="icon" variant="ghost" className="h-9 w-9 text-slate-400 hover:text-rose-600" onClick={onRemove} data-testid={`build-bill-driver-remove${tid}`}><Trash2 className="h-4 w-4" /></Button>}
      </div>
      {!entry.driverId && <Input className="mt-1.5 h-8" placeholder="Driver name as given (optional)" value={entry.driverName} onChange={(e) => onChange({ ...entry, driverName: e.target.value })} data-testid={`build-bill-driver-name${tid}`} />}
      {hasMvr && (
        <div className="mt-2 grid grid-cols-[1fr_80px] gap-2 rounded-md border border-emerald-200 bg-emerald-50 p-2" data-testid={`build-bill-mvr-dl${tid}`}>
          <div><Label className="text-xs">Driver's license #</Label><Input className="h-8 bg-white font-mono" value={entry.dlNumber} onChange={(e) => onChange({ ...entry, dlNumber: e.target.value })} placeholder="DL number" data-testid={`build-bill-dl-number${tid}`} /></div>
          <div><Label className="text-xs">DL state</Label><Input className="h-8 bg-white font-mono uppercase" maxLength={2} value={entry.dlState} onChange={(e) => onChange({ ...entry, dlState: e.target.value.toUpperCase() })} placeholder="TX" disabled={!!entry.driverId} data-testid={`build-bill-dl-state${tid}`} /></div>
          {!entry.driverId && <div className="col-span-2 text-[11px] text-emerald-800">No driver on file — the DL state sets the MVR state fee.</div>}
        </div>
      )}
      {hasResult && entry.driverId && <ResultDrop entry={entry} onChange={onChange} tid={tid} />}
    </div>
  );
}

export function AddDriverButton({ onClick, disabled }) {
  return (
    <Button type="button" size="sm" variant="outline" className="h-8" onClick={onClick} disabled={disabled} data-testid="build-bill-add-driver">
      <Plus className="h-3.5 w-3.5 mr-1" />Add another driver
    </Button>
  );
}
